import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import Link from '@/presentation/reusables/Link';

const LegendContainer = styled.div`
  margin-bottom: 50px;
  width: 100%;
  max-width: 1120px;
  min-width: 1120px;

  .scheduleModalLegend {
    background-color: var(--background-background-UTP);
    padding: 12px;
    border-radius: 8px;
    margin-top: 16px;
    margin-bottom: 12px;

    p {
      width: fit-content;
      border-radius: 20px;
      text-align: center;
      padding: 4px 12px;
      font-family: Lato;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      text-align: left;
      margin-bottom: 2px;
    }

    ul {
      margin-left: 25px;
      margin-bottom: 4px;
    }
    li {
      span {
        position: relative;
        left: -5px;
      }
    }
  }
`;

const LegendComponent = () => (
  <LegendContainer>
    <Text
      color={'#161631'}
      fontSize={'14px'}
      fontWeight={700}
      level={1}
      style={{ marginBottom: '16px' }}
    >
      Modalidad de curso:
    </Text>
    <div className="scheduleModalLegend">
      <p
        style={{
          background: 'var(--decorative-decorative10)',
          color: 'var(--background-tag-background10)'
        }}
      >
        Virtual 24/7
      </p>
      <ul>
        <li>
          <span>
            Todo el material disponible 24/7 en la plataforma UTP+class.
          </span>
        </li>
        <li>
          <span>
            Tu docente te acompañará y resolverá tus dudas en el momento en que
            lo necesites.
          </span>
        </li>
        <li>
          <span>
            Flexibilidad para conectarte en cualquier momento y del dispositivo
            que más te acomode.
          </span>
        </li>
      </ul>
      <p
        style={{
          background: 'var(--decorative-decorative11)',
          color: 'var(--background-tag-background09)'
        }}
      >
        Virtual en vivo
      </p>
      <ul>
        <li>
          <span>Clases por la plataforma Zoom en un horario específico.</span>
        </li>
        <li>
          <span>
            Las clases quedarán grabadas en caso no puedas conectarte.
          </span>
        </li>
      </ul>
      <p
        style={{
          background: 'var(--decorative-decorative09)',
          color: 'var(--background-tag-background11)'
        }}
      >
        Presencial
      </p>
      <ul>
        <li>
          <span>Clases en tu campus en un horario específico.</span>
        </li>
      </ul>
    </div>
    <ul style={{ paddingLeft: '20px' }}>
      <li>
        Tienes acceso a todos tus materiales en{' '}
        <Link
          linkType="external"
          url="https://class.utp.edu.pe/"
          linkName="UTP+class."
        />
      </li>
    </ul>
  </LegendContainer>
);

export default LegendComponent;
